var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h14c7.542 0 11.314 0 13.657 2.343S46 8.458 46 16v14c0 7.542 0 11.314-2.343 13.657S37.543 46 30 46H16c-7.542 0-11.314 0-13.657-2.343S0 37.543 0 30V16z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h14c7.542 0 11.314 0 13.657 2.343S46 8.458 46 16v14c0 7.542 0 11.314-2.343 13.657S37.543 46 30 46H16c-7.542 0-11.314 0-13.657-2.343S0 37.543 0 30V16z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.87 24.068 3.07 8.501s.384.796.796.796c.41 0 6.526-6.363 6.526-6.363l6.801-13.135-17.084 8.007-.11 2.194z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.942 26.25-.59 6.267s-.247 1.92 1.673 0 3.757-3.4 3.757-3.4",
    fill: "#A9C6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.926 24.376-6.318-2.058s-.755-.307-.512-1.001c.05-.143.151-.265.453-.475 1.4-.976 25.91-9.785 25.91-9.785s.692-.233 1.1-.078a.597.597 0 0 1 .407.443c.044.182.062.37.055.558-.002.162-.022.312-.037.548-.15 2.409-4.616 20.385-4.616 20.385S30.1 33.965 29.143 34a1.755 1.755 0 0 1-1.278-.495c-1.88-1.616-8.375-5.981-9.81-6.941a.274.274 0 0 1-.118-.195c-.02-.1.09-.226.09-.226s11.31-10.053 11.61-11.108c.024-.082-.064-.122-.182-.086-.751.276-13.773 8.5-15.21 9.407a.692.692 0 0 1-.32.02z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 23,
    y1: 46,
    x2: 23,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h14c7.542 0 11.314 0 13.657 2.343S46 8.458 46 16v14c0 7.542 0 11.314-2.343 13.657S37.543 46 30 46H16c-7.542 0-11.314 0-13.657-2.343S0 37.543 0 30V16z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.ccfb546ea5b284d521752bb8e04d3e63.svg";
export { ForwardRef as ReactComponent };